import { SortParams } from '../../typings/grid';
import {
    Marketer,
    MarketerAddProductForm,
    MarketerProduct,
    MarketerProductsCellItem,
    MarketersPageStates
} from '../../typings/marketers';

export const FETCH_MARKETER_CARD_DATA = 'FETCH_MARKETER_CARD_DATA';
export type FETCH_MARKETER_CARD_DATA = typeof FETCH_MARKETER_CARD_DATA;

export const ADD_MARKETER_PRODUCT = 'ADD_MARKETER_PRODUCT';
export type ADD_MARKETER_PRODUCT = typeof ADD_MARKETER_PRODUCT;

export const CHANGE_MARKETER_PRODUCT = 'CHANGE_MARKETER_PRODUCT';
export type CHANGE_MARKETER_PRODUCT = typeof CHANGE_MARKETER_PRODUCT;

export const CHANGE_MARKETER_CARD_PAGE_STATUS =
    'CHANGE_MARKETER_CARD_PAGE_STATUS';
export type CHANGE_MARKETER_CARD_PAGE_STATUS = typeof CHANGE_MARKETER_CARD_PAGE_STATUS;

export const UPDATE_MARKETER_CARD_DATA = 'UPDATE_MARKETER_CARD_DATA';
export type UPDATE_MARKETER_CARD_DATA = typeof UPDATE_MARKETER_CARD_DATA;

export const UPDATE_MARKETER_PRODUCT = 'UPDATE_MARKETER_PRODUCT';
export type UPDATE_MARKETER_PRODUCT = typeof UPDATE_MARKETER_PRODUCT;

export const FETCH_ADD_MARKETER_PRODUCT = 'FETCH_ADD_MARKETER_PRODUCT';
export type FETCH_ADD_MARKETER_PRODUCT = typeof FETCH_ADD_MARKETER_PRODUCT;

export const CHANGE_MARKETER_ADD_PRODUCT_FORM =
    'CHANGE_MARKETER_ADD_PRODUCT_FORM';
export type CHANGE_MARKETER_ADD_PRODUCT_FORM = typeof CHANGE_MARKETER_ADD_PRODUCT_FORM;

export const CHANGE_MARKETER_ACCESS_CELL = 'CHANGE_MARKETER_ACCESS_CELL';
export type CHANGE_MARKETER_ACCESS_CELL = typeof CHANGE_MARKETER_ACCESS_CELL;

export const FETCH_REMOVE_MARKETER_PRODUCT = 'FETCH_REMOVE_MARKETER_PRODUCT';
export type FETCH_REMOVE_MARKETER_PRODUCT = typeof FETCH_REMOVE_MARKETER_PRODUCT;

export const REMOVE_MARKETER_PRODUCT = 'REMOVE_MARKETER_PRODUCT';
export type REMOVE_MARKETER_PRODUCT = typeof REMOVE_MARKETER_PRODUCT;

export const SORT_MARKETER_PRODUCTS = 'SORT_MARKETER_PRODUCTS';
export type SORT_MARKETER_PRODUCTS = typeof SORT_MARKETER_PRODUCTS;

export interface ChangeMarketerAddProductFormAction {
    type: CHANGE_MARKETER_ADD_PRODUCT_FORM;
    form: MarketerAddProductForm;
}

export interface FetchMarketerCardAction {
    type: FETCH_MARKETER_CARD_DATA;
    id: string;
}

export interface FetchAddMarketerProductAction {
    type: FETCH_ADD_MARKETER_PRODUCT;
}

export interface AddMarketerProductAction {
    type: ADD_MARKETER_PRODUCT;
    product: MarketerProduct;
    sortParams?: SortParams;
}

export interface ChangeMarketerProductAction {
    type: CHANGE_MARKETER_PRODUCT;
    product: MarketerProduct;
}

export interface ChangeMarketerCardPageStatusAction {
    type: CHANGE_MARKETER_CARD_PAGE_STATUS;
    pageStatus: MarketersPageStates;
}

export interface UpdateMarketerCardDataAction {
    type: UPDATE_MARKETER_CARD_DATA;
    marketer: Marketer;
    sortParams?: SortParams;
}

export interface UpdateMarketerProductAction {
    type: UPDATE_MARKETER_PRODUCT;
    product: MarketerProduct;
}

export interface ChangeMarketerAccessCellAction {
    type: CHANGE_MARKETER_ACCESS_CELL;
    product: MarketerProductsCellItem;
}

export interface FetchRemoveMarketerProductAccessAction {
    type: FETCH_REMOVE_MARKETER_PRODUCT;
    productId: string;
}

export interface RemoveMarketerProductAccessAction {
    type: REMOVE_MARKETER_PRODUCT;
    productId: string;
}

export interface SortMarketerProductsAction {
    type: SORT_MARKETER_PRODUCTS;
    sortParams: SortParams;
}

export function changeMarketerAddProductForm(
    form: MarketerAddProductForm
): ChangeMarketerAddProductFormAction {
    return {
        type: CHANGE_MARKETER_ADD_PRODUCT_FORM,
        form
    };
}

export function fetchMarketerCardData(id: string): FetchMarketerCardAction {
    return {
        type: FETCH_MARKETER_CARD_DATA,
        id
    };
}

export function changeMarketerProduct(
    product: MarketerProductsCellItem
): ChangeMarketerProductAction {
    const { isEdited, selectedAccess, ...oldProduct } = product;
    const newProduct: MarketerProduct = {
        ...oldProduct,
        access: selectedAccess
    };

    return {
        type: CHANGE_MARKETER_PRODUCT,
        product: newProduct
    };
}

export function fetchAddMarketerProduct(): FetchAddMarketerProductAction {
    return {
        type: FETCH_ADD_MARKETER_PRODUCT
    };
}

export function addMarketerProduct(
    product: MarketerProduct,
    sortParams?: SortParams
): AddMarketerProductAction {
    return {
        type: ADD_MARKETER_PRODUCT,
        product,
        sortParams
    };
}

export function setMarketerCardPageStatus(
    pageStatus: MarketersPageStates
): ChangeMarketerCardPageStatusAction {
    return {
        type: CHANGE_MARKETER_CARD_PAGE_STATUS,
        pageStatus
    };
}

export function updateMarketerCardData(
    marketer: Marketer,
    sortParams?: SortParams
): UpdateMarketerCardDataAction {
    return {
        type: UPDATE_MARKETER_CARD_DATA,
        marketer,
        sortParams
    };
}

export function updateMarketerProduct(
    product: MarketerProduct
): UpdateMarketerProductAction {
    return {
        type: UPDATE_MARKETER_PRODUCT,
        product
    };
}

export function changeMarketerAccessCell(
    product: MarketerProductsCellItem
): ChangeMarketerAccessCellAction {
    return {
        type: CHANGE_MARKETER_ACCESS_CELL,
        product
    };
}

export function fetchRemoveMarketerProductAccess(
    productId: string
): FetchRemoveMarketerProductAccessAction {
    return {
        type: FETCH_REMOVE_MARKETER_PRODUCT,
        productId
    };
}

export function removeMarketerProductAccess(
    productId: string
): RemoveMarketerProductAccessAction {
    return {
        type: REMOVE_MARKETER_PRODUCT,
        productId
    };
}

export const MARKETERS_OFFSET_GRID = 'MARKETERS_OFFSET_GRID';
export type MARKETERS_OFFSET_GRID = typeof MARKETERS_OFFSET_GRID;
export interface MarketersOffsetGridAction {
    type: MARKETERS_OFFSET_GRID;
    offset: number;
}

export function marketersSetGridOffset(
    offset: number
): MarketersOffsetGridAction {
    return {
        type: MARKETERS_OFFSET_GRID,
        offset
    };
}

export function sortMarketerProducts(
    sortParams: SortParams
): SortMarketerProductsAction {
    return {
        type: SORT_MARKETER_PRODUCTS,
        sortParams
    };
}

export type MarketerCardAction =
    | AddMarketerProductAction
    | FetchMarketerCardAction
    | FetchAddMarketerProductAction
    | ChangeMarketerProductAction
    | ChangeMarketerAccessCellAction
    | ChangeMarketerCardPageStatusAction
    | ChangeMarketerAddProductFormAction
    | UpdateMarketerCardDataAction
    | UpdateMarketerProductAction
    | FetchRemoveMarketerProductAccessAction
    | RemoveMarketerProductAccessAction
    | MarketersOffsetGridAction
    | SortMarketerProductsAction;
